import React, { FC, useState, useEffect } from 'react';
import Udesk from 'Udesk';
import { Button, Modal, Space, Card, Descriptions } from 'udesk-ui';
import { FormProps } from 'udesk-ui/es/form-builder';
import UdeskLocales from 'UdeskLocales';
import { IntelligentPartnerDialogNodeAiTemplateFoundResponse } from 'src/api/types';
import UdeskPagination from 'Component/common/udesk-pagination';
import styled from 'styled-components';
import { useSdkOptions } from 'src/util/hook';
import { CustomerPortraitConfig } from 'Component/pages/components/coach/CustomerPortrait';

const Div = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const Scroller = styled.div`
    padding: 5px 5px 10px;
    overflow: auto;
`;

type FormHeaderProps = {
    form: FormProps<any>['form'];
};

const FormHeader: FC<FormHeaderProps> = (props) => {
    const { form } = props;
    const [loading, setLoading] = useState(false);
    const sdkOptions = useSdkOptions();
    const { allCustomerPortrait } = CustomerPortraitConfig.useCustomerPortraitConfigContext();
    // 分页配置
    const [paging, setPaging] = useState({
        pageNum: 1,
        pageSize: 4,
        total: 0,
    });

    // 分页变化
    const pageChanged = (pageNum: number, pageSize: number) => {
        setPaging((prev) => ({
            ...prev,
            pageNum,
            pageSize,
        }));
    };

    const [roles, setRoles] = useState<IntelligentPartnerDialogNodeAiTemplateFoundResponse[]>([]);

    // 获取列表数据
    const fetchList = async () => {
        setLoading(true);
        try {
            const url = Udesk.business.apiPath.concatApiPath(
                `/review/intelligentPartner/node/inputSceneConfig/template?pageNum=${paging.pageNum}&pageSize=${paging.pageSize}`,
                sdkOptions
            );
            await Udesk.ajax.get(url).then(
                (resp) => {
                    setRoles(resp.data || []);
                    setPaging({
                        ...paging,
                        total: resp.paging.total,
                    });
                },
                (reason) => {}
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paging.pageNum, paging.pageSize]);

    const [visible, setVisible] = useState(false);

    const onOpen = () => {
        setVisible(true);
    };

    const onCancel = () => {
        setVisible(false);
    };

    const onChoose = (r: IntelligentPartnerDialogNodeAiTemplateFoundResponse) => {
        const customer = allCustomerPortrait.find((item) => item.id === r.id);
        const tags = customer?.customerTags?.reduce<any[]>((acc, curr) => {
            return [...acc, ...(curr.tags?.map((item) => item.id) ?? [])];
        }, []);
        form?.setFieldsValue?.({
            dialogueScene: r.dialogueScene,
            simulatedRole: r.id,
            sparringPartner: r.sparringPartner,
            useDesc: customer?.desc,
            userTag: tags || [],
            robotTimbre: r.robotTimbre,
            robotTimbreConfig: JSON.stringify({
                voice: r.robotTimbreConfig,
                gender: r.robotTimbre,
                volume: 50,
                pitchRate: 0,
                speechRate: 0,
            }),
        });
        setVisible(false);
    };

    return (
        <Div>
            <Button type="link" disabled={loading} onClick={onOpen}>
                {/* 从模板库中选择 */}
                {
                    UdeskLocales['current'].pages.coach.courseManagement.flow.components.const
                        .nodeConfigs.aiGenSceneNode.selectFromTemplateLibrary
                }
            </Button>

            <Modal
                title={
                    /* 模版库 */ UdeskLocales['current'].pages.coach.courseManagement.flow
                        .components.const.nodeConfigs.aiGenSceneNode.templateLibrary
                }
                visible={visible}
                footer={null}
                onCancel={onCancel}
                width={1000}
            >
                <Scroller>
                    <Space>
                        {roles.map((r) => (
                            <Card
                                style={{ width: 220, height: 320 }}
                                hoverable
                                onClick={() => onChoose(r)}
                            >
                                <Descriptions title={null} column={1}>
                                    <Descriptions.Item label="场景名称">
                                        {r.templateName}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="建议角色">
                                        {r.simulatedRoleName}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="陪练对象">
                                        {r.sparringPartner}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="场景描述">
                                        {r.dialogueScene}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>
                        ))}
                    </Space>
                </Scroller>
                <div className="pagination-wrapper">
                    {roles.length > 0 ? (
                        <UdeskPagination
                            current={paging.pageNum}
                            pageSize={paging.pageSize}
                            total={paging.total}
                            showSizeChanger={false}
                            onChange={pageChanged}
                        />
                    ) : null}
                </div>
            </Modal>
        </Div>
    );
};

export default FormHeader;
